import { render, staticRenderFns } from "./GlobalConf.vue?vue&type=template&id=71a38bcb&scoped=true&"
import script from "./GlobalConf.vue?vue&type=script&lang=js&"
export * from "./GlobalConf.vue?vue&type=script&lang=js&"
import style0 from "./GlobalConf.vue?vue&type=style&index=0&id=71a38bcb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a38bcb",
  null
  
)

export default component.exports